import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getExtremeKitHealthRecordsFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const extremeKit = categorySpecificInfo.extremeKit;
  if (!isRecord(extremeKit)) {
    return [];
  }

  const attachments = extremeKit.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const healthRecords = attachments.healthRecords;
  if (!isRecord(healthRecords) || !Array.isArray(healthRecords.files)) {
    return [];
  }

  return healthRecords.files as SmartTagAttachmentFile[];
};

export const withExtremeKitHealthRecordsFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const extremeKit = isRecord(categorySpecificInfo.extremeKit)
    ? categorySpecificInfo.extremeKit
    : {};
  const attachments = isRecord(extremeKit.attachments)
    ? extremeKit.attachments
    : {};
  const healthRecords = isRecord(attachments.healthRecords)
    ? attachments.healthRecords
    : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      extremeKit: {
        ...extremeKit,
        attachments: {
          ...attachments,
          healthRecords: {
            ...healthRecords,
            files,
          },
        },
      },
    },
  };
};

export const persistExtremeKitHealthRecordsFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const vcardRef = doc(db, `users/${userId}/vcards/active`, "extremeKit");
  await updateDoc(vcardRef, {
    "categorySpecificInfo.extremeKit.attachments.healthRecords.files": files,
    updatedAt: serverTimestamp(),
  });
};
